import * as Actions from '../actions'
import * as Constants from '../constants'
import * as Processes from '@rushplay/processes'
import * as R from 'ramda'
import * as Request from '../request'

import {bind} from 'redux-effects'
import {createPaymentMethodId} from '../create-provider-id'

function transformTransactionType(txType) {
  switch (txType) {
    case 'deposit': {
      return Constants.TransactionType.DEPOSIT
    }
    case 'withdraw': {
      return Constants.TransactionType.WITHDRAWAL
    }

    default: {
      throw new Error(`Unknown transaction type: ${txType}`)
    }
  }
}

function transformPaymentMethods(paymentMethods, txType) {
  return R.reduce(
    (methods, method) => {
      const transactionType = transformTransactionType(method.transaction_type)

      if (transactionType === txType) {
        const backendType = Constants.BackendType.NODAPAY

        return R.append(
          {
            accounts: [],
            backendType,
            canAddAccount: true,
            id: createPaymentMethodId({
              backendType,
              providerType: method.provider,
              transactionType,
            }),
            limit: {
              max: `${method.limits.max_cents / 100}`,
              min: `${method.limits.min_cents / 100}`,
            },
            providerType: method.provider,
            transactionType,
          },
          methods
        )
      }

      return methods
    },
    [],
    paymentMethods
  )
}

export function fetchPaymentMethods(params) {
  const processId = `nodapay/fetch-payments-methods`
  return [
    Processes.start(processId),
    bind(
      Request.createRequest({
        backendType: Constants.BackendType.NODAPAY,
        requestData: {
          countryCode: params.countryCode,
        },
        requestHeaders: {
          Accept: 'application/vnd.casinosaga.v1, application/json',
          Authorization: R.defaultTo('', params.sessionId),
        },
        requestMethod: 'GET',
        urlTemplate: '/nodapay/payment_methods{?countryCode}',
      }),
      (res) => [
        Actions.updatePaymentMethods(
          transformPaymentMethods(res.value, params.transactionType)
        ),
        Processes.stop(processId),
      ],
      (error) => {
        if (process.env.NODE_ENV !== 'production') {
          // Pass real error to console for easier debugging
          // eslint-disable-next-line no-console
          console.error(error)
        }

        return [
          Actions.updatePaymentMethods(
            new Error('errors.nodapay.fetch-payment-methods-failure')
          ),
          Processes.stop(processId),
        ]
      }
    ),
  ]
}

export function performTransaction() {
  return Actions.startTransaction({
    redirectOutput: {container: 'nodapay'},
    transactionState: Constants.TransactionState.WAITING_INPUT,
  })
}
